import { render, staticRenderFns } from "./AffiliatedWrapper.vue?vue&type=template&id=9d5852dc&"
import script from "./AffiliatedWrapper.vue?vue&type=script&lang=ts&"
export * from "./AffiliatedWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports